define(function(){
	const IPS = require('../../base/ipsModelCollection');
	const vm = require('civicsUtils/view_manager');
	return IPS.extend({
		urlRoot : '/delegate/civics-api/api/',
		url:function(){
			var useFilterCode = vm.versionRange('8.5.0.1711', '8.6') || vm.versionRange('8.6.0.1712');
			var url = this.urlRoot;
			if( useFilterCode ){
				//We should have the code type, CDR Family, AP Type and possibly the work Type
				url += 'cdr/FilterCodes?codeType={0}&type={1}&applicationType={2}';
				url = url.format( this.codeType, this.productFamily, this.encodeComponent(this.applicationType));

				if( this.workType )
					url += '&WorkType=' + this.encodeComponent(this.workType);

				if(this.capacityType)
					url += '&CapacityType=' + this.encodeComponent(this.capacityType);
								
			}
			else {
				url += 'core/codedescriptions/';
				// set the moniker and it will append it to the url
		      	if (this.moniker)
					url += this.moniker;
			}
			return url;
		},
		parse:function(r){
		  if( r.data.codeDescriptionItems ){
			  _.each(r.data.codeDescriptionItems, function (codeDescript) {
				  if( codeDescript.description == null || codeDescript.description.trim().length <= 0 ){
					  	codeDescript.description = i18n.t('CIVICS.COMMON.VALUE_NOT_CONFIG');
				  }
			  });
		  }
		  else {
			  _.each(r.data, function (codeDescript) {
				  if( codeDescript.description == null || codeDescript.description.trim().length <= 0 ){
					  	codeDescript.description = i18n.t('CIVICS.COMMON.VALUE_NOT_CONFIG');
				  }
			  });
		  }

	      this.responseStatus = r.responseStatus;
	      return r.data.codeDescriptionItems ? r.data.codeDescriptionItems : r.data;
	   }
	});
});
